module.exports = __webpack_public_path__ + "c9bd22dc90df6a9c879b7207924836e6.fbx";